import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

import { AuthHttpClient } from '../../../../providers/auth-http.service';

import { default as swal } from 'sweetalert2';


export class SharedHackService {

	public baseUrl: string = '/v1/hack/';
	public baseUrlV3: string = '/v3/hack/';

	constructor(private http: Http, private sHttp: AuthHttpClient) {}

	public getHack(clientId: string, hackId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/overview';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackByUuid(clientId: string, hackUuid: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack_uuid/' + hackUuid + '/overview';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getChallengesTags(clientId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/challenge/tags';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackResults(clientId: string, candidateId: string, hackId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/candidate/' + candidateId + '/hack/' + hackId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch((error) => {
				if (error.status === 402) {
					return Observable.throw(error);
				}
				return this.handleError(error);
			});
	}

	public getHackUiEvents(clientId: string, candidateUuid: string, hackUuid: string): Observable<any> {
		let url = this.baseUrlV3 + 'auth/client/hack/' + hackUuid + '/candidate/' + candidateUuid + '/events';
		return this.sHttp.get(url)
			.map((resp) => {
				if (resp._body && resp._body !== '') {
					return resp.json();
				}
				return {};
			})
			.catch((error) => {
				return Observable.of(null);
			});
	}

	public getSupportedCodingLanguages(clientId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/languages/config';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackReports(clientId: string, candidateId: string, hackId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/candidate/' + candidateId + '/hack/' + hackId + '/report';
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getExternalTests(clientId: string, queryParams?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_tests';
		return this.sHttp.get(url, queryParams)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getExternalTest(clientId: string, testId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postExternalTest(clientId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test';
		let body: string = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public patchExternalTest(clientId: string, testId: string, field: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/' + field;
		let body: string = JSON.stringify(data);
		return this.sHttp.patch(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public finishExternalTest(clientId: string, testId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/status/finished';
		return this.sHttp.patch(url, '')
			.map(this.extractData)
			.catch(this.handleError);
	}

	public doInProgressExternalTest(clientId: string, testId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/status/in_progress';
		return this.sHttp.patch(url, '')
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteExternalTestInvitations(clientId: string, testId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/invitations';
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public archiveExternalTest(clientId: string, testId: string, value: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/is_archived';
		let body = JSON.stringify({value});
		return this.sHttp.patch(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getExternalTestInvitations(clientId: string, testId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/invitations';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getExternalTestInvitationsCount(clientId: string, testId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/invitations/stats';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postExternalTestsInvitation(clientId: string, testId: string, data: any, preventHandleErr = false): Observable<any> {
		let body: string = JSON.stringify(data);
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/' + testId + '/invitation';
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch((err) => {
				if (!preventHandleErr) {
					return this.handleError(err);
				}
				return Observable.throw(err);
			});
	}

	public postExternalTestsInvitationNotification(clientId: string, invitationId: string, data: any, preventHandleErr = false): Observable<any> {
		let body: string = JSON.stringify(data);
		let url = this.baseUrl + 'auth/client/' + clientId + '/external_test/invitation/' + invitationId + '/notification';
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch((err) => {
				if (!preventHandleErr) {
					return this.handleError(err);
				}
				return Observable.throw(err);
			});
	}

	public getKnwoledgeTestQuestionsLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/knowledge-test/questions';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postKnwoledgeTestQuestionLibrary(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/knowledge-test';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postKnowledgeTestQuestion(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/knowledge-test';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public uploadClientFile(clientId: string, file: File, category: string): Observable<any> {
		let url = '/v1/file/auth/client/' + clientId + '/file';
		let formData = new FormData();
		formData.append('file_location', file, file.name);
		formData.append('category', category);
		// the file endpoint returns a flat object — extractData's first-key unwrap would discard it
		return this.sHttp.postMultipart(url, formData)
			.map((res: any) => res.json())
			.catch(this.handleError);
	}

	public deleteKnwoledgeTestQuestion(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/knowledge-test/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getKnwoledgeTestQuestionLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/knowledge-test/question/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getKnwoledgeTestQuestion(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/knowledge-test/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public updateKnowledgeTestProperties(clientId: string, challengeId: string, properties: Partial<{
		priority: number
		is_accepting_partial_response: boolean
		allow_comment: boolean
		weight: number }>) {
		let url = this.baseUrl + 'auth/client/' + clientId + '/knowledge-test/' + challengeId;
		return this.sHttp.patch(url, JSON.stringify(properties))
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackarootChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/hackaroot-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackarootChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/hackaroot-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getHackarootChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hackaroot/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postHackarootChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/hackaroot';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteHackarootChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hackaroot/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectUploadChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/project-upload-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectUploadChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/project-upload-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectUploadChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/project-upload/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postProjectUploadChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/project-upload';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteProjectUploadChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/project-upload/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getCodingChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/coding-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postCodingChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/coding';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public updateChallengeDescription(clientId: string, challengeId: string, data: any): Observable<any> {
		let body = JSON.stringify(data);
		let url = this.baseUrl + 'auth/client/' + clientId + '/coding/' + challengeId;
		return this.sHttp.patch(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteCodingChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/coding/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getCodingChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/coding/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getCodingChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/coding-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/project-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/project-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postProjectChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/project';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteProjectChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/project/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getProjectChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/project/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getDiagramChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/diagram-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getDiagramChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/diagram-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postDiagramChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/diagram';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteDiagramChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/diagram/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getDiagramChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/diagram/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getWebChallengesLibrary(clientId: string, params?: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/web-challenges';
		return this.sHttp.get(url, params)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getWebChallengeLibrary(clientId: string, libId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/library/web-challenge/' + libId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public getWebChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/web/' + challengeId;
		return this.sHttp.get(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public postWebChallenge(clientId: string, hackId: string, data: any): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/hack/' + hackId + '/web';
		let body = JSON.stringify(data);
		return this.sHttp.post(url, body)
			.map(this.extractData)
			.catch(this.handleError);
	}

	public deleteWebChallenge(clientId: string, challengeId: string): Observable<any> {
		let url = this.baseUrl + 'auth/client/' + clientId + '/web/' + challengeId;
		return this.sHttp.delete(url)
			.map(this.extractData)
			.catch(this.handleError);
	}

	private extractData(res: Response) {
		if (res) {
			let resp: any = res;
			if (resp._body && resp._body !== '') {
				let body = res.json();
				if (typeof Object.keys(body)[0] !== 'undefined') {
					return body[Object.keys(body)[0]];
				}
			}
			return {};
		}
	}

	private handleError(error: any) {
		let errMsg = (error.message) ? error.message :
		error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg);
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(errMsg);
	}
static ctorParameters() { return [ { type: Http }, { type: AuthHttpClient } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/services/shared-hack.service.ts